import { ChevronLeft, ChevronRight } from 'lucide-react';

import { Button } from '@/components/ui/Button';
import { cn } from '@/lib/utils';

interface PaginationProps {
  className?: string;
  page: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  nextPage: () => void;
  previousPage: () => void;
}

export function PaginationV2({
  className,
  page,
  totalPages,
  hasNextPage,
  hasPreviousPage,
  nextPage,
  previousPage,
}: PaginationProps) {
  return (
    <div
      className={cn(
        'flex flex-row items-center justify-between gap-2',
        className,
      )}
    >
      <span className="text-sm text-muted-foreground">
        Page <span className="font-medium">{page}</span> de{' '}
        <span className="font-medium">{totalPages}</span>
      </span>

      <div className="flex items-center gap-1">
        <Button
          variant="ghost"
          size="icon"
          onClick={previousPage}
          disabled={!hasPreviousPage}
          className="rounded-xl transition-all hover:bg-gray-200 hover:text-gray-900 disabled:opacity-40"
        >
          <ChevronLeft className="h-4 w-4 hover:stroke-[2.5]" />
        </Button>

        <span className="px-3 text-sm font-semibold text-foreground">
          {page}
        </span>

        <Button
          variant="ghost"
          size="icon"
          onClick={nextPage}
          disabled={!hasNextPage}
          className="rounded-xl transition-all hover:bg-gray-200 hover:text-gray-900 disabled:opacity-40"
        >
          <ChevronRight className="h-4 w-4 hover:stroke-[2.5]" />
        </Button>
      </div>
    </div>
  );
}
